// extracted by mini-css-extract-plugin
export default {"container":"InfiniteScrollLoader_container__jvjIS"};